var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadfileico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 52,
    viewBox: "0 0 39 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 13.9232V0.376343H2.4375C1.08672 0.376343 0 1.44216 0 2.76697V48.9857C0 50.3105 1.08672 51.3763 2.4375 51.3763H36.5625C37.9133 51.3763 39 50.3105 39 48.9857V16.3138H25.1875C23.8469 16.3138 22.75 15.2381 22.75 13.9232ZM29.3698 35.4398H22.75V43.4086C22.75 44.2891 22.0228 45.0023 21.125 45.0023H17.875C16.9772 45.0023 16.25 44.2891 16.25 43.4086V35.4398H9.63016C8.17984 35.4398 7.4557 33.7176 8.48555 32.7145L18.2782 23.1819C18.9536 22.5235 20.0444 22.5235 20.7198 23.1819L30.5124 32.7145C31.5433 33.7176 30.8202 35.4398 29.3698 35.4398ZM38.2891 10.8353L28.3461 1.07361C27.8891 0.625366 27.2695 0.376343 26.6195 0.376343H26V13.1263H39V12.5187C39 11.8912 38.7461 11.2836 38.2891 10.8353Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadfileico);
export default __webpack_public_path__ + "static/media/uploadfileico.b447e7d0ea993f4a5702a7ebd60cb84a.svg";
export { ForwardRef as ReactComponent };